/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspage_Add_Story1Inputs */

const vi_cmspage_add_story1 = /** @type {(inputs: Cmspage_Add_Story1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm câu chuyện`)
};

/**

* @param {Cmspage_Add_Story1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspage_add_story1 = /** @type {((inputs?: Cmspage_Add_Story1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspage_Add_Story1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspage_add_story1(inputs)
});
export { cmspage_add_story1 as "cmsPage_add_story" }